/** Idle / cleared activity — hide ThinkingOrb. */
export const IDLE_ACTIVITY = Object.freeze({
  orbState: 'working',
  label: '',
  chromeLabel: '',
  active: false,
})

export const THINKING_ACTIVITY = Object.freeze({
  orbState: 'working',
  label: 'Thinking…',
  chromeLabel: 'THINKING',
  active: true,
})

export const LISTENING_ACTIVITY = Object.freeze({
  orbState: 'listening',
  label: 'Listening…',
  chromeLabel: 'LISTENING',
  active: true,
})

export const CREATING_ACTIVITY = Object.freeze({
  orbState: 'shaping',
  label: 'Creating tickets…',
  chromeLabel: 'CREATING',
  active: true,
})

const TOOL_ACTIVITIES = {
  ticket_draft_tickets: {
    orbState: 'composing',
    label: 'Drafting tickets…',
    chromeLabel: 'DRAFTING',
  },
  context_index_repo: {
    orbState: 'solving',
    label: 'Indexing repository…',
    chromeLabel: 'INDEXING',
  },
  ticket_approve_draft: {
    orbState: 'shaping',
    label: 'Creating tickets…',
    chromeLabel: 'CREATING',
  },
  jira_create_issue: {
    orbState: 'shaping',
    label: 'Creating tickets…',
    chromeLabel: 'CREATING',
  },
  asana_create_task: {
    orbState: 'shaping',
    label: 'Creating tickets…',
    chromeLabel: 'CREATING',
  },
}

const SEARCH_TOOL_RE = /(?:^|_)(?:search|list|suggest)_|(?:^|_)search(?:_|$)|intake_from_github_issue|context_search_/i

/**
 * Map a tool name to orb state + labels.
 * @param {string|null|undefined} toolName
 * @returns {{ orbState: string, label: string, chromeLabel: string, active: boolean }}
 */
export function mapToolToActivity(toolName) {
  if (!toolName) return { ...THINKING_ACTIVITY }

  const exact = TOOL_ACTIVITIES[toolName]
  if (exact) {
    return { ...exact, active: true }
  }

  if (SEARCH_TOOL_RE.test(toolName)) {
    return {
      orbState: 'searching',
      label: 'Searching context…',
      chromeLabel: 'SEARCHING',
      active: true,
    }
  }

  return {
    orbState: 'working',
    label: 'Working…',
    chromeLabel: 'WORKING',
    active: true,
  }
}

/**
 * Map an ActionCable stage event to orb activity.
 * @param {{ stage?: string, data?: { tool?: string }, message?: string }} event
 */
export function mapRealtimeEvent(event) {
  if (!event) return IDLE_ACTIVITY

  const stage = event.stage
  if (stage === 'completed' || stage === 'failed') return IDLE_ACTIVITY

  if (stage === 'tool' || stage === 'tool_call') {
    return mapToolToActivity(event.data?.tool)
  }

  if (stage === 'thinking' || stage === 'tool_result' || stage === 'started' || stage === 'drafting') {
    if (stage === 'drafting') {
      return mapToolToActivity('ticket_draft_tickets')
    }
    return { ...THINKING_ACTIVITY }
  }

  return IDLE_ACTIVITY
}

/**
 * Resolve display activity from voice / busy / realtime / publish flags.
 */
export function resolveAgentActivity({
  voiceActive = false,
  busy = false,
  realtimeActivity = IDLE_ACTIVITY,
  publishing = false,
} = {}) {
  if (voiceActive) return { ...LISTENING_ACTIVITY }
  if (publishing) return { ...CREATING_ACTIVITY }
  if (realtimeActivity?.active) return realtimeActivity
  if (busy) return { ...THINKING_ACTIVITY }
  return IDLE_ACTIVITY
}
